export enum CrossFrameMessageType {
  Minimize = 'MINIMIZE',
  ChatServed = 'CHAT_SERVED',
  ChatInitiated = 'CHAT_INITIATED',
  ChatEnded = 'CHAT_ENDED',
  BookingClosed = 'BOOKING_CLOSED',
  ChatClosed = 'CHAT_CLOSED',
  ChatTransferred = 'CHAT_TRANSFERRED',
}

const postMessage = (messageType: CrossFrameMessageType, payload?: any): void => {
  (parent as any).postMessage({ messageType, payload }, '*'); // eslint-disable-line no-restricted-globals
};

export default postMessage;
